<template>
  <header class="light-bb">
    <nav class="navbar navbar-expand-lg navbar-light">
      <router-link class="navbar-brand" to="/">
        <img v-if="$store.state.theme" src="/img/logo.jpg" alt="" />
        <img v-else src="/img/logo.jpg" alt="" />
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNav"
        aria-controls="headerNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="headerNav">
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <router-link class="nav-link active" aria-current="page" to="/">Exchange</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" to="markets">Markets</router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown1"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Dashboard
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="navbarDropdown1"
            >
              <li>
                <router-link class="dropdown-item" to="profile"
                  >Profile</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="wallet"
                  >Wallet</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="settings"
                  >Settings</router-link
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown2"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Pages
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="navbarDropdown2"
            >
              <li>
                <router-link class="dropdown-item" to="login"
                  >Login</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="sign-up"
                  >Sign up</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="lock">Lock</router-link>
              </li>
              <li>
                <router-link class="dropdown-item" to="otp-number"
                  >OTP Number</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="otp-verify"
                  >OTP Verify</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="reset"
                  >Reset</router-link
                >
              </li>
              <li>
                <router-link class="dropdown-item" to="404">404</router-link>
              </li>
            </ul>
          </li> -->
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item header-custom-icon">
            <a href="#" class="nav-link" @click="toggleDark">
              <i v-if="$store.state.theme" class="icon ion-md-moon"></i>
              <i v-else class="icon ion-md-sunny"></i>
            </a>
          </li>
          <li class="nav-item dropdown header-custom-icon" @click="$router.push('/notice-list')">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown4" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="icon ion-md-notifications"></i>
            </a>

          </li>
          <li class="nav-item dropdown header-img-icon" v-if="$store.state.isLogin">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown5" role="button"
              :data-bs-toggle="$store.state.isLogin ? 'dropdown' : ''" aria-expanded="false"
              @click="handleDropdownClick">
              <img :src="userInfo
                ? userInfo.img
                  ? userInfo.img
                  : 'img/avatar.svg'
                : 'img/avatar.svg'
                " class="header-avatar-image" alt="avatar" />
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown5">
              <router-link to="/user/profile" v-if="userInfo">
                <div class="dropdown-header d-flex flex-column align-items-center">
                  <!-- <div class="figure mb-3">
                    <img :src="userInfo.img" alt="" />
                  </div> -->
                  <div class="info text-center">
                    <p class="name font-weight-bold mb-0">
                      {{ userInfo.nickname }}
                    </p>
                    <p class="email text-muted mb-3">
                      ID:{{ userInfo.user_id }}
                    </p>
                    <p class="email mb-3">Blance:{{ userInfo.money }}</p>
                  </div>
                </div>
              </router-link>
              <div class="dropdown-body">
                <ul class="profile-nav">
                  <li class="nav-item">
                    <router-link to="/user/profile" class="nav-link">
                      <i class="icon ion-md-person"></i>
                      <span>Profile</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/user/wallet" class="nav-link">
                      <i class="icon ion-md-wallet"></i>
                      <span>My Wallet</span>
                    </router-link>
                  </li>
                  <!-- <li class="nav-item">
                    <router-link to="/user/settings" class="nav-link">
                      <i class="icon ion-md-settings"></i>
                      <span>Settings</span>
                    </router-link>
                  </li> -->
                  <li class="nav-item">
                    <a href="#" class="nav-link red" @click="logout">
                      <i class="icon ion-md-power"></i>
                      <span>Log Out</span>
                    </a>
                  </li>
                </ul>
              </div>
            </ul>
          </li>
          <li class="nav-item dropdown header-img-icon" v-else>
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown5" role="button" aria-expanded="false"
              @click="handleDropdownClick">
              <img src="/img/avatar.svg" class="header-avatar-image" alt="avatar" />
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>

export default {
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    toggleDark: function () {
      this.$store.commit("changeTheme");
      document.body.classList.toggle("dark");
    },
    handleDropdownClick() {
      if (!this.$store.state.isLogin) {
        this.$router.push("/login");
      } else {
        this.$store.dispatch("getUserInfo");
      }
    },
    logout() {
      this.$store.dispatch("clearLoginData");
      this.$router.push("/login");
    },
  }
};
</script>
<style lang="scss" scoped>
@media (max-width: 991px) {
  .navbar {
    position: relative;

    &>.navbar-collapse {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      z-index: 1000;
      background: #fff;
      box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.1);

      &.show {
        height: 41px;
      }

      &.collapsing {
        .navbar-nav {
          visibility: hidden;
        }
      }

      &.show.collapse {
        display: flex;
        padding-right: 1rem;
      }

      .navbar-nav {
        display: inline-flex;
        flex-direction: row;
      }

      .nav-item {
        .dropdown-menu {
          position: absolute;

          &::before {
            left: inherit;
            right: 5%;
          }
        }
      }
    }
  }

  .dark {
    .navbar {
      &>.navbar-collapse {
        padding: 0 10px;
        background: #131722;
      }
    }
  }
}
</style>
